var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "详情",
        visible: _vm.visible,
        width: "800px",
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "detail-content" },
        [
          _c(
            "el-table",
            {
              staticClass: "detail-table",
              attrs: {
                data: _vm.tableData,
                border: "",
                stripe: "",
                size: "small",
                "show-header": false,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "label", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "label-text" }, [
                          _vm._v(_vm._s(scope.row.label)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "value", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "value-text" }, [
                          _vm._v(_vm._s(scope.row.value)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }